import { Ifetch } from "../initialState";

export interface IMostObservedObjects {
  count: number;
  name: string;
}

export interface IfetchMostObservedObjects extends Ifetch {
  data: IMostObservedObjects[];
  totalCount: number;
}

const mostObservedObjectsInitialState: IfetchMostObservedObjects = {
  data: [],
  totalCount: 0,
  message: "",
  stateIs: "Pending",
};
export default mostObservedObjectsInitialState;
